/**
 * HubSpot CRM object types the SMS contact picker can be opened from
 * The value doubles as the widget route segment and the id query key, so it must
 * match what api-core builds into the CRM card URL.
 */
export const CrmObjectType = Object.freeze({
  DEAL: 'deal',
  TICKET: 'ticket'
})

/**
 * What each object is called in the picker's on-screen copy
 */
export const CrmObjectLabel = Object.freeze({
  [CrmObjectType.DEAL]: 'deal',
  [CrmObjectType.TICKET]: 'ticket'
})

/**
 * The card URL query key carrying the record id, per object type
 */
export const CrmObjectIdQueryKey = Object.freeze({
  [CrmObjectType.DEAL]: 'hs_deal_id',
  [CrmObjectType.TICKET]: 'hs_ticket_id'
})

/**
 * HubSpot's objectTypeId per CRM object, as the calling SDK's navigateToRecord takes it
 */
export const HubSpotObjectTypeId = Object.freeze({
  CONTACT: '0-1'
})
